import { render } from "./HODHome.vue?vue&type=template&id=1bae5c16&scoped=true"
import script from "./HODHome.vue?vue&type=script&lang=js"
export * from "./HODHome.vue?vue&type=script&lang=js"

import "./HODHome.vue?vue&type=style&index=0&id=1bae5c16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bae5c16"]])

export default __exports__